export const transactionsEn = {
  'balance-transaction_title': 'Transactions',
  'balance-available_balance': 'Available Balance:',
  'balance-back_title': 'Back',
  'balance-refresh': 'Refresh',
  'balance-date': 'Date',
  'balance-transaction_type': 'Transaction Type',
  'balance-amount': 'Amount',
  'balance-status': 'Status',
  'balance-merchant_info': 'Merchant Information',
  'balance-previous': 'Previous',
  'balance-next': 'Next',
  'balance-page': 'Page',
  'balance-transaction-empty-default': 'No transactions available for this PRN!',
  'balance-transaction-empty-filter': 'No transactions available for this filter!',
  'balance-transaction-loading': 'Fetching transactions...',
  'transaction-status-settled': 'Settled',
  'transaction-status-pending': 'Pending',
};

export const transactionsFr = {
  'balance-transaction_title': 'Transactions',
  'balance-available_balance': 'Solde disponible:',
  'balance-back_title': 'Retour',
  'rbalance-efresh': 'Rafraichir',
  'balance-date': 'Date',
  'balance-transaction_type': 'Type de Transaction',
  'balance-amount': 'Montant',
  'balance-status': 'Statut',
  'balance-merchant_info': 'Informations du Commerçant',
  'balance-previous': 'Précedent',
  'balance-next': 'Suivant',
  'balance-page': 'Page',
  'balance-transaction-empty-default': 'Aucune transaction disponible pour ce PRN!',
  'balance-transaction-empty-filter': 'Aucune transaction disponible pour ce filtre!',
  'balance-transaction-loading': 'Chargement des transactions...',
  'transaction-status-settled': 'Réglé',
  'transaction-status-pending': 'En attente',
};
